// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Nav_nav__XCV7F {
  position: fixed;
  top: 0;
  left: 0;
  height: 80px;
  width: 100%;
  background: #040404;
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  z-index: 1000;
  transition: all 0.3s ease;
  font-family: 'Urbanist', sans-serif;
}

.Nav_nav__XCV7F.Nav_scrolled__XbCwU {
  background-color: rgba(0, 0, 0, 0.8);
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
}

.Nav_container__A9FAB {
  max-width: 1600px;
  height: 100%;
  margin: 0 auto;
  padding: 0 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.Nav_gradientText__sd3MG {
  font-size: 3rem;
  font-weight: bold;
  font-family: "neuropol-nova", "neuropol nova", sans-serif;
  font-style: normal;
  cursor: pointer;
  font-weight: 400;
  background: linear-gradient(
    to right,
    #00f5d4,
    #0094ff,
    #6a5af9,
    #d958ff,
    #ff427b
  );
  background-size: 300% 300%;
  background-clip: text;
  -webkit-background-clip: text;
  color: transparent;
  animation: Nav_gradientAnimation__cw4iN 8s ease infinite;
  margin: 0;
  padding: 0;
  white-space: nowrap;
  display: block;
  text-align: center;
  position: relative;
  z-index: 3;
  line-height: 1.2;
}

@keyframes Nav_gradientAnimation__cw4iN {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}

.Nav_desktopMenu__Y9vUV {
  display: flex;
  align-items: center;
}

.Nav_menuItems__CQTJY {
  display: flex;
  list-style: none;
  margin: 0;
  padding: 0;
}

.Nav_menuItems__CQTJY li {
  margin: 0 20px;
}

.Nav_menuItems__CQTJY li a {
  color: white;
  text-decoration: none;
  font-size: 16px;
  font-weight: 500;
  transition: color 0.3s ease;
}

.Nav_menuItems__CQTJY li a:hover {
  color: #00f5d4;
}

.Nav_burgerMenu__xOJqf {
  display: none;
  flex-direction: column;
  justify-content: space-between;
  width: 30px;
  height: 20px;
  cursor: pointer;
  z-index: 1001;
}

.Nav_burgerBar__\\+HXCL {
  width: 100%;
  height: 2px;
  background-color: white;
  transition: all 0.3s ease;
}

.Nav_burgerBar__\\+HXCL.Nav_open__70gze:nth-child(1) {
  transform: translateY(9px) rotate(45deg);
}

.Nav_burgerBar__\\+HXCL.Nav_open__70gze:nth-child(2) {
  opacity: 0;
}

.Nav_burgerBar__\\+HXCL.Nav_open__70gze:nth-child(3) {
  transform: translateY(-9px) rotate(-45deg);
}

.Nav_mobileMenu__Pnu01 {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.95);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  transform: translateY(-100%);
  transition: transform 0.4s ease;
  z-index: 999;
}

.Nav_mobileMenu__Pnu01.Nav_open__70gze {
  transform: translateY(0);
}

.Nav_mobileMenuItems__TzCZN {
  list-style: none;
  padding: 0;
  margin: 0;
  text-align: center;
}

.Nav_mobileMenuItems__TzCZN li {
  margin: 20px 0;
}

.Nav_mobileMenuItems__TzCZN li a {
  color: white;
  text-decoration: none;
  font-size: 24px;
  font-weight: 500;
  transition: color 0.3s ease;
}

.Nav_mobileMenuItems__TzCZN li a:hover {
  color: #00f5d4;
}

.Nav_mobileLaunchButton__xDXV6 {
  margin-top: 30px;
  padding: 12px 30px;
  font-size: 16px;
}

@media (max-width: 900px) {
  .Nav_desktopMenu__Y9vUV {
    display: none;
  }
  
  .Nav_burgerMenu__xOJqf {
    display: flex;
  }
}

@media (min-width: 901px) {
  .Nav_mobileMenu__Pnu01 {
    display: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Nav/Nav.module.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,2BAA2B;EAC3B,mCAAmC;EACnC,aAAa;EACb,yBAAyB;EACzB,mCAAmC;AACrC;;AAEA;EACE,oCAAoC;EACpC,yCAAyC;AAC3C;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,yDAAyD;EACzD,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB;;;;;;;GAOC;EACD,0BAA0B;EAC1B,qBAAqB;EACrB,6BAA6B;EAC7B,kBAAkB;EAClB,wDAA6C;EAC7C,SAAS;EACT,UAAU;EACV,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,WAAW;EACX,YAAY;EACZ,eAAe;EACf,aAAa;AACf;;AAEA;EACE,WAAW;EACX,WAAW;EACX,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,aAAa;EACb,qCAAqC;EACrC,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,4BAA4B;EAC5B,+BAA+B;EAC/B,YAAY;AACd;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,aAAa;EACf;AACF","sourcesContent":[".nav {\n  position: fixed;\n  top: 0;\n  left: 0;\n  height: 80px;\n  width: 100%;\n  background: #040404;\n  backdrop-filter: blur(10px);\n  -webkit-backdrop-filter: blur(10px);\n  z-index: 1000;\n  transition: all 0.3s ease;\n  font-family: 'Urbanist', sans-serif;\n}\n\n.nav.scrolled {\n  background-color: rgba(0, 0, 0, 0.8);\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);\n}\n\n.container {\n  max-width: 1600px;\n  height: 100%;\n  margin: 0 auto;\n  padding: 0 20px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.gradientText {\n  font-size: 3rem;\n  font-weight: bold;\n  font-family: \"neuropol-nova\", \"neuropol nova\", sans-serif;\n  font-style: normal;\n  cursor: pointer;\n  font-weight: 400;\n  background: linear-gradient(\n    to right,\n    #00f5d4,\n    #0094ff,\n    #6a5af9,\n    #d958ff,\n    #ff427b\n  );\n  background-size: 300% 300%;\n  background-clip: text;\n  -webkit-background-clip: text;\n  color: transparent;\n  animation: gradientAnimation 8s ease infinite;\n  margin: 0;\n  padding: 0;\n  white-space: nowrap;\n  display: block;\n  text-align: center;\n  position: relative;\n  z-index: 3;\n  line-height: 1.2;\n}\n\n@keyframes gradientAnimation {\n  0% {\n    background-position: 0% 50%;\n  }\n  50% {\n    background-position: 100% 50%;\n  }\n  100% {\n    background-position: 0% 50%;\n  }\n}\n\n.desktopMenu {\n  display: flex;\n  align-items: center;\n}\n\n.menuItems {\n  display: flex;\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n\n.menuItems li {\n  margin: 0 20px;\n}\n\n.menuItems li a {\n  color: white;\n  text-decoration: none;\n  font-size: 16px;\n  font-weight: 500;\n  transition: color 0.3s ease;\n}\n\n.menuItems li a:hover {\n  color: #00f5d4;\n}\n\n.burgerMenu {\n  display: none;\n  flex-direction: column;\n  justify-content: space-between;\n  width: 30px;\n  height: 20px;\n  cursor: pointer;\n  z-index: 1001;\n}\n\n.burgerBar {\n  width: 100%;\n  height: 2px;\n  background-color: white;\n  transition: all 0.3s ease;\n}\n\n.burgerBar.open:nth-child(1) {\n  transform: translateY(9px) rotate(45deg);\n}\n\n.burgerBar.open:nth-child(2) {\n  opacity: 0;\n}\n\n.burgerBar.open:nth-child(3) {\n  transform: translateY(-9px) rotate(-45deg);\n}\n\n.mobileMenu {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100vh;\n  background-color: rgba(0, 0, 0, 0.95);\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  transform: translateY(-100%);\n  transition: transform 0.4s ease;\n  z-index: 999;\n}\n\n.mobileMenu.open {\n  transform: translateY(0);\n}\n\n.mobileMenuItems {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  text-align: center;\n}\n\n.mobileMenuItems li {\n  margin: 20px 0;\n}\n\n.mobileMenuItems li a {\n  color: white;\n  text-decoration: none;\n  font-size: 24px;\n  font-weight: 500;\n  transition: color 0.3s ease;\n}\n\n.mobileMenuItems li a:hover {\n  color: #00f5d4;\n}\n\n.mobileLaunchButton {\n  margin-top: 30px;\n  padding: 12px 30px;\n  font-size: 16px;\n}\n\n@media (max-width: 900px) {\n  .desktopMenu {\n    display: none;\n  }\n  \n  .burgerMenu {\n    display: flex;\n  }\n}\n\n@media (min-width: 901px) {\n  .mobileMenu {\n    display: none;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"nav": `Nav_nav__XCV7F`,
	"scrolled": `Nav_scrolled__XbCwU`,
	"container": `Nav_container__A9FAB`,
	"gradientText": `Nav_gradientText__sd3MG`,
	"gradientAnimation": `Nav_gradientAnimation__cw4iN`,
	"desktopMenu": `Nav_desktopMenu__Y9vUV`,
	"menuItems": `Nav_menuItems__CQTJY`,
	"burgerMenu": `Nav_burgerMenu__xOJqf`,
	"burgerBar": `Nav_burgerBar__+HXCL`,
	"open": `Nav_open__70gze`,
	"mobileMenu": `Nav_mobileMenu__Pnu01`,
	"mobileMenuItems": `Nav_mobileMenuItems__TzCZN`,
	"mobileLaunchButton": `Nav_mobileLaunchButton__xDXV6`
};
export default ___CSS_LOADER_EXPORT___;
